module.exports = __webpack_public_path__ + "assets/images/covid-hits-home-1.jpg?v=4c8ad819";